import React from "react";
import { SvgIcon } from "@material-ui/core";
import { ReactComponent as HandshakeIcon } from "../../../images/handshake.svg";

const _HandshakeIcon = (props) => {
  return <SvgIcon component={HandshakeIcon} {...props} />;
};

export default _HandshakeIcon;
